import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/layout/Home'
import NewPage from '@/layout/NewPage'
Vue.use(Router)
const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/NewPage',
      name: 'NewPage',
      component: NewPage,
    }
  ]
})
router.afterEach(()=>{
  document.body.scrollTop =0;
  document.documentElement.scrollTop =0;
  })
export default router